import { EnrollmentComment } from '../../lib/types/models/enrollment-comment/enrollment-comment'
import { EnrollmentCommentInput } from '../../lib/types/models/enrollment-comment/enrollment-comment-input'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createEnrollmentComment(data: IdInput<EnrollmentCommentInput>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.enrollments.createEnrollmentComment.url, { id }))
    .post<EnrollmentComment, EnrollmentCommentInput>(rest)
}
